<template>
  <div id="contact-background">

    <div class="row justify-content-center" >

      <div class="col-10 col-sm-3 col-md-4">
        <div class="icon-container mx-auto">
          <a href="tel:+46738000099">
            <img class="phone-icon" src="/static/images/icons/icon_smartphone_white.svg">
          </a>
        </div>
        <div class="text-container text-center mx-auto">
          <a href="tel:+46738000099">{{ $t('message.contact.phoneNumber') }}</a>
        </div>
      </div>

      <div class="col-10 col-sm-3 col-md-4">
        <div class="icon-container mx-auto pb-2 pb-sm-4 pb-md-5">
          <a class="location-icon" target="_blank" href="https://goo.gl/maps/tfbtCBNpFwQ2">
            <img src="/static/images/icons/icon_address_white.svg">
          </a>
        </div>
        <div class="text-container  text-center mx-auto">
          <p>{{ $t('message.contact.address') }} {{ $t('message.contact.city') }}</p>
          <p>{{ $t('message.contact.floor') }}</p>
        </div>
      </div>

      <div class="col-10 col-sm-3 col-md-4">
        <div class="icon-container mx-auto">
          <a href="mailto:info@precisit.se">
            <img class="mail-icon" src="/static/images/icons/mail-icon.svg">
          </a>
        </div>
        <div class="text-container  text-center mx-auto">
          <a href="mailto:info@precisit.se">{{ $t('message.contact.emailInfo') }}</a>
          <a href="mailto:jobb@precisit.se">{{ $t('message.contact.emailJob') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHero from '@/components/shared/PageHero';
import PageFooter from '../shared/PageFooter';

export default {
  name: 'ContactPageNew',
  components: {
    PageFooter,
    PageHero,
  },
  data() {
    return {
      title: 'Contact page',
    };
  },
  methods: {
    // eslint-disable-next-line
    scroll: function () {
      window.scrollBy(0, 700);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';
@import '../../assets/styles/_slanted.scss';

#contact-background {
  background-image: url('/static/images/space_background/top-space-high.jpg'), url('/static/images/space_background/top-space-md.jpg'), url('/static/images/space_background/top-space-sm.jpg');
  background-size: cover;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  p {
    color:$white;
    font-size: 17px;
    margin-bottom: 0.3rem;
    @include media-breakpoint-down(md) {
      font-size: 15px;
    }
  }
}

.text-container {
  width: 190px;
  height: 50px;
  margin: 0;
  a {
    color: $white;
    font-size: 17px;
    margin-bottom: 0.3rem;
    @include media-breakpoint-down(md) {
      font-size: 15px;
    }
  }
}

.icon-container {
  width: 190px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  img:hover {
    cursor: pointer;
    transform: scale(1.2);
  }

}

.phone-icon {
  width: 47px;
}
.mail-icon {
  width: 79px;
}

.location-icon {
  width: 66px;
}


</style>
